<template>
  <page-wrapper title="รายการคูปองส่วนลด" :hasPad="true">
    <sc-button variant="primary" :route="{ name: 'CouponAddPage' }"
      >เพิ่มคูปอง</sc-button
    >
    <hr />
    <div class="row mb-3 padding-adjust">
      <div class="col-2">
        <div class="label mb-2">รหัสคูปองส่วนลด</div>
        <el-input v-model="code" />
      </div>
      <div class="col-2">
        <div class="label mb-2">ประเภท</div>
        <el-select v-model="statusQuery" clearable>
          <el-option
            v-for="t in status"
            :key="t.value"
            :label="t.label"
            :value="t.value"
          ></el-option>
        </el-select>
      </div>

    </div>
    <div class="text-right padding-adjust">
      <sc-button variant="primary" @click="handleClickSearch">ค้นหา</sc-button>
    </div>
    <div class="coupon-list">
      <div class="coupon-list-item header">
        <div class="code">รหัสส่วนลด</div>
        <div class="usage-quota">จำนวนสิทธิ์</div>
        <div class="usage-quota-per-user">จำนวนสิทธิ์ต่อคน</div>
        <div class="discount">ยอดลด</div>
        <div class="usage-period">ระยะเวลาใช้งาน</div>
        <div class="minimum-purchase">ยอดซื้อขั้นต่ำ</div>
        <div class="maximum-discount">ยอดลดสูงสุด</div>
        <div class="is-first-time">เฉพาะลูกค้าครั้งแรก</div>
      </div>
      <router-link
        :key="coupon.id"
        :to="coupon.route"
        class="coupon-list-item"
        v-for="coupon in couponsPresenter"
      >
        <div class="code">
          <label class="label">รหัสส่วนลด</label>
          {{ coupon.code }}
        </div>
        <div class="usage-quota">
          <label class="label">จำนวนสิทธิ์</label>
          {{ coupon.usageQuota }}
        </div>
        <div class="usage-quota-per-user">
          <label class="label">จำนวนสิทธิ์ต่อคน</label>
          {{ coupon.usageQuotaPerUser }}
        </div>
        <div class="discount">
          <label class="label">ยอดลด</label>
          {{ coupon.discount }}
        </div>
        <div class="usage-period">
          <label class="label">ระยะเวลาใช้งาน</label>
          {{ coupon.usagePeriod }}
        </div>
        <div class="minimum-purchase">
          <label class="label">ยอดซื้อขั้นต่ำ</label>
          {{ coupon.minimumPurchase }}
        </div>
        <div class="maximum-discount">
          <label for class="label">ยอดลดสูงสุด</label>
          {{ coupon.maximumDiscount }}
        </div>
        <div class="is-first-time">
          <label for class="label">เฉพาะลูกค้าครั้งแรก</label>
          {{ coupon.isFirstTimeOnly }}
        </div>
      </router-link>
      <div class="not-found-item" v-if="coupons.length === 0">ไม่พบข้อมูล</div>
    </div>
    <div class="wrapper text-right padding-adjust">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="10"
        :current-page="queryParams.page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import { toLocaleTH } from "@/lib/dateTime";
import { DateTime } from "luxon";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { formatToMoney } from "@/lib/formatter";
import { Pagination, Input, Select, Option } from "element-ui";

export default {
  components: {
    PageWrapper,
    ScButton,
    "el-input": Input,
    "el-pagination": Pagination,
    "el-select": Select,
    "el-option": Option,
  },
  data() {
    const coupons = [];
    const total = 0;
    const code = "";
    const status = [
      { label: "ทั้งหมด", value: "" },
      { label: "Active", value: "active" },
      { label: "Expired", value: "expired" }
    ]

    return {
      coupons,
      total,
      code,
      status,
      statusQuery: null
    };
  },
  computed: {
    couponsPresenter() {
      return this.coupons
        .filter(coupon => !Boolean(coupon.deleted_at))
        .map(coupon => {
          const {
            id,
            code,
            effective_date,
            expired_days_after_transfered,
            expiry_date,
            discount_amount,
            discount_percent_amount,
            maximum_discount_amount,
            minimum_purchased_amount,
            usage_quota,
            usage_quota_per_user,
            is_first_time_only
          } = coupon;
          const usageQuota = usage_quota
            ? usage_quota.toLocaleString()
            : "ไม่จำกัด";
            const usageQuotaPerUser = usage_quota_per_user
            ? usage_quota_per_user
            : "1";
          const discount = discount_amount
            ? `${formatToMoney(discount_amount)} บาท`
            : `${discount_percent_amount}%`;

          const effectiveDate = toLocaleTH(DateTime.fromISO(effective_date));
          const expiryDate = toLocaleTH(DateTime.fromISO(expiry_date));

          const isSameYear = effectiveDate.hasSame(expiryDate, "year");
          const isSameMonth = effectiveDate.hasSame(expiryDate, "month");

          const format = "d MMM yyyy";

          let usagePeriod = ''
          if (expired_days_after_transfered === null) {
            usagePeriod = !isSameYear
              ? `${effectiveDate.toFormat(format)} - ${expiryDate.toFormat(
                  format
                )}`
              : !isSameMonth
              ? `${effectiveDate.toFormat("dd MMM")} - ${expiryDate.toFormat(
                  format
                )}`
              : `${effectiveDate.toFormat("dd")} - ${expiryDate.toFormat(
                  format
                )}`;
          } else {
            usagePeriod = expired_days_after_transfered + ' days from transfer date'
          }

          const minimumPurchase = minimum_purchased_amount
            ? `${formatToMoney(minimum_purchased_amount)} บาท`
            : "ไม่มี";
          const maximumDiscount = maximum_discount_amount
            ? `${formatToMoney(maximum_discount_amount)} บาท`
            : "ไม่จำกัด";

          const route = {
            name: "CouponDetailPage",
            params: { id }
          };

          const isFirstTimeOnly = is_first_time_only;

          return {
            id,
            code,
            discount,
            usagePeriod,
            minimumPurchase,
            maximumDiscount,
            usageQuota,
            usageQuotaPerUser,
            route,
            isFirstTimeOnly
          };
        });
    },
    queryParams() {
      return {
        page: parseInt(this.$route.query.page) || 1,
        code: this.code || "",
        statusQuery: this.statusQuery || ""
      };
    }
  },
  watch: {
    async "$route.query"(query) {
      await this.setupData();
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupCoupons();
    },
    async setupCoupons() {
      const response = await baanRueJaiClient.admin.subscriptions.coupons.list(
        this.queryParams
      );
      const { coupons, count } = response.data.result;

      this.coupons = coupons;
      this.total = count;
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    handleClickSearch() {
      const route = {
        query: {
          ...this.$route.query,
          code: this.code,
          page: 1,
          status: this.statusQuery
        }
      };

      this.$router.replace(route);
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-list-item {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: row;
  grid-gap: 15px;

  padding: 15px;
  border-bottom: 1px solid #ddd;

  text-decoration: none;

  &:not(.header):hover {
    color: black;
    background: #eee;
  }

  > * > .label {
    margin: 0;
    display: block;
    font-weight: bold;
    font-size: 14px;
  }

  &.header {
    display: none;
  }

  @media (min-width: 1200px) {
    grid-auto-columns: 1fr;
    grid-template-columns: none;
    grid-auto-flow: column;

    > .usage-quota,
    > .usage-quota-per-user {
      text-align: right;
    }
    > .discount,
    > .minimum-purchase,
    > .maximum-discount {
      text-align: right;
    }

    > .usage-period {
      text-align: center;
    }
    > .is-first-time {
      text-align: center;
    }

    &.header {
      display: grid;
      font-size: 14px;
      font-weight: bold;
    }

    > * > .label {
      display: none;
    }
  }
}

.padding-adjust {
  padding: 10px 0;
}

.not-found-item {
  border-bottom: 1px solid #ddd;
  padding: 15px;
  text-align: center;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/coupons/pages/CouponListPage.vue